import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react"
import type { FC } from "react"
import { EXTERNAL_ROUTES } from "@/common/constants/routes"
import ReportSection from "@/proposal/components/simulation/common/ReportSection"
import type { SimulationResultType } from "@/proposal/components/simulation/common/SimulationResultBadge"
import SimulationResultBadge from "@/proposal/components/simulation/common/SimulationResultBadge"
import type { Maybe, ThreatAnalysis } from "@/query/graphql"

type Props = {
  threatAnalysis?: Maybe<ThreatAnalysis>
  result?: SimulationResultType
}
const HexagateReportSection: FC<Props> = ({ threatAnalysis, result }) => {
  const threatAnalysisEvents =
    threatAnalysis?.actionsData?.flatMap(
      (actionsData) =>
        actionsData?.events?.filter((event) => event.severity !== "None") ?? [],
    ) ?? null

  return (
    <ReportSection
      learnMoreLink={{
        url: EXTERNAL_ROUTES.simulations.hexagate(),
        label: "Learn more about Hexagate",
      }}
      result={result}
      title="Hexagate simulations"
    >
      {threatAnalysisEvents && threatAnalysisEvents.length > 0 ? (
        <TableContainer
          border="1px"
          borderColor="gray.200"
          borderRadius="md"
          width="full"
        >
          <Table>
            <Thead>
              <Tr>
                <Th px={3} py={3}>
                  Details
                </Th>
                <Th isNumeric pr={10} py={3}>
                  Result
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {threatAnalysisEvents.map((event, idx) => (
                <Tr key={`threat-analysis-${idx}`}>
                  <Th px={3} py={3}>
                    {event.eventType}: {event.description}
                  </Th>
                  <Th isNumeric px={3} py={3}>
                    {event.severity}
                    <SimulationResultBadge
                      result={event.severity as SimulationResultType}
                    />
                  </Th>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Box p={3}>
          <Text>No threats detected</Text>
        </Box>
      )}
    </ReportSection>
  )
}

export default HexagateReportSection
